import React from 'react'

import { constants } from 'helpers'
import Button from 'components/Button'

const { H_NUMBERS, WAITLIST_STATUS_CONFIG, WAITLIST_STATUS } = constants

const DecisionOptions = ({ payload, status, onSubmit, onChange }) => {
  const requiresHNum =
    status === WAITLIST_STATUS.DATABASE_PENDING &&
    payload.decision === WAITLIST_STATUS.DATABASE_APPROVED

  if (status === WAITLIST_STATUS.YES) {
    return null
  }

  return (
    <div className="flex items-center">
      <div className="flex items-center mr-4">
        <span className="mr-2 text-white text-lg">Decision</span>
        <select
          value={payload.decision}
          onChange={onChange}
          name="decision"
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-100 p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option checked={!payload.decision ? 'checked' : null} value="">
            Select
          </option>
          {WAITLIST_STATUS_CONFIG[status]?.actions.map(action => (
            <option value={action} key={action}>
              {WAITLIST_STATUS_CONFIG[action.toLowerCase()]?.state || action}
            </option>
          ))}
        </select>
      </div>
      {requiresHNum && (
        <div>
          <div className="flex items-center mr-4">
            <span className="mr-2 text-white text-lg">H#</span>
            <select
              value={payload.h_num}
              onChange={onChange}
              name="h_num"
              className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 block w-100 p-2 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            >
              <option checked={!payload.h_num ? 'checked' : null} value={0}>
                Select
              </option>
              {H_NUMBERS.map(v => (
                <option value={v} key={v} checked={payload.h_num === v ? 'checked' : null}>
                  {v}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
      <Button
        className="flex items-center bg-blueViolet h-10"
        onClick={onSubmit}
        disabled={(requiresHNum && !payload.h_num) || !payload.decision}
      >
        <span className="text-sm text-black text-white">Submit</span>
      </Button>
    </div>
  )
}

export default DecisionOptions
